import { Image, Input, Box, Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, CloseButton } from '@chakra-ui/react'
import { useEffect, useState, useContext, useMemo } from 'react'
import { CountingAPI } from 'apis/CountingAPI'
import { CountingTabsContext } from 'components/Counting/CountingTabs/CountingTabs'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/image-gallery.css'
import useAuthStore from '../../../../stores/authStore'


const Galery = () => {
  
  const [ images, setImages ] = useState([])
  const [selectedImage, setSelectedImage] = useState(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const user = useAuthStore((state) => state.user)
  const { counting } = useContext(CountingTabsContext)

  const handleFileUpload = (event) => {
    if(!event.target.files.length) return
    const formData = new FormData()
    formData.append('file', event.target.files[0])
    CountingAPI.photoUpload(counting._id, formData).then((response) => {
      setImages(response.file_list)
    })
  }

  const handleDeletePhoto = (photo) => {
    if (!window.confirm('למחוק את התמונה?')) return
    
    const fileName = photo.split('/').pop()
      CountingAPI.photoDelete(counting._id, fileName)
        .then(() => {
            setImages((prevImages) =>
                prevImages.filter((image) => image !== photo)
            )
            setSelectedImage(null)
        })
        .catch((error) => {
            console.error('Error deleting photo:', error)
        })
}

  useEffect(() => {
    CountingAPI.photoList(counting._id).then((response) => {
      setImages(response.file_list)
    })
  }, [counting._id])

  const galleryImages = useMemo( () =>
      images.map((image) => ({ 
        original: `${process.env.REACT_APP_API_BASE_URL}/storage/${image.replace('public/', '')}`, 
        thumbnail: `${process.env.REACT_APP_API_BASE_URL}/storage/${image.replace('public/', '')}`, 
        photo: image
      })),
      [images]
    )
  
  return (
    <Box  p='4'
          w='100%'
          borderWidth='1px'
         >
          <Input type='file' accept='image/*' onChange={handleFileUpload}/>
      {images.length > 0 && (
      <Box mt={4} w='100%'>
        <ImageGallery 
                    items={galleryImages}
                    showPlayButton={false}
                    showFullscreenButton={false}
                    showNav={true}
                    showBullets={false}
                    showThumbnails={true}
                    thumbnailPosition='left'
                    lazyLoad={true} 
                    renderItem={(item) => ( 
                        <Box w='100%' h='400px' display='flex' alignItems='center' justifyContent='center' bg='gray.50' > 
                            <Image src={item.original} alt='' maxW='100%' maxH='100%' objectFit='contain' /> 
                        </Box>
                              )}
                    onBeforeSlide={(nextIndex) => setCurrentImageIndex(nextIndex)}
                    onClick={() => {setSelectedImage(currentImageIndex)}}
                    renderThumbInner={(item) => (
                        <Box position='relative' w='80px' h='60px' role='group'>
                            <Image src={item.thumbnail} alt='' w='100%' h='100%' objectFit='cover' />
                        {(user?.is_admin && (
                        <CloseButton  position='absolute'
                                      top='4px'
                                      right='4px'
                                      w='16px'
                                      h='16px'
                                      minW='16px'
                                      borderRadius='full'
                                      bg='blackAlpha.600'
                                      color='white'
                                      opacity={0}
                                      _groupHover={{ opacity: 1 }}
                                      _hover={{ bg: 'blackAlpha.800' }}
                                      transition='opacity 0.15s ease, background-color 0.15s ease, transform 0.15s ease'
                                      zIndex='2'
                                      aria-label='Delete photo'
                                      onClick={(event) => {event.stopPropagation()
                                                handleDeletePhoto(item.photo)
                                              }}
                        />
                        ))} 
                        </Box>  
                    )}
        /> 

                        <Modal isOpen={selectedImage !== null} onClose={() => setSelectedImage(null)} size='6xl' isCentered>
                          <ModalOverlay />
                              <ModalContent w='90vw' maxW='1200px' h='90vh'>
                              <ModalCloseButton zIndex='10' />
                              <ModalBody p='6' w='100%' h='100%'>
                                        <Box w='100%' h='100%' 
                                             sx={{
                                              '& .image-gallery': { height: '100%' },
                                              '& .image-gallery-content': {
                                                  height: '100%',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  },
                                              '& .image-gallery-slide-wrapper': {
                                                  flex: '1 1 auto',
                                                  minHeight: 0,
                                                  height: 'auto',
                                                  },
                                              '& .image-gallery-swipe, & .image-gallery-slides, & .image-gallery-slides-container': {
                                                  height: '100%',
                                                  },
                                              '& .image-gallery-slide': {
                                                  height: '100%',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  },
                                              '& .image-gallery-slide .image-gallery-image': {
                                                  width: '100%',
                                                  height: '100%',
                                                  objectFit: 'contain',
                                                  },
                                              '& .image-gallery-thumbnails-wrapper.bottom': {
                                                  flex: '0 0 auto',
                                                  marginTop: '8px',
                                                  },
                                          }}
                                        >
                                        <ImageGallery
                                            items={galleryImages}
                                            showPlayButton={false}
                                            showFullscreenButton={false}
                                            showNav={true}
                                            showBullets={false}
                                            showThumbnails={true}
                                            thumbnailPosition='bottom'
                                            lazyLoad={true}
                                            startIndex={selectedImage ?? 0}
                                        />
                                        </Box>
                                  </ModalBody>
                              </ModalContent>
                          </Modal>                 
      </Box>
      )
      }
    </Box>
  )
}

export default Galery
